import { useEffect, useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useSelector } from 'react-redux';
import * as EventTrackingActions from './ducks/actions';
import { Initialize } from './ducks/reducer';

const getEventTrackingData = (eventData, vehicle, dashboard, core) => {
  const { stockNumber, vehicleId } = vehicle || {};
  const { userId } = core || {};
  const { status: { purchaseId } = {} } = dashboard || {};

  return {
    ...eventData,
    stockNumber,
    vehicleId,
    userId,
    purchaseId
  };
};

const EventTracking = ({ registry }) => {
  const { eventTracking: { eventData, eventName, track } = {} } =
    useSelector(state => state) || {};

  const { vehicle, dashboard, core } = useSelector(state => state) || {};

  const { trackEvent } = useContext(AnalyticsContext);
  const { EventTracked } = EventTrackingActions;

  useEffect(() => {
    if (registry) Initialize(registry);
  }, []);

  useEffect(() => {
    if (track) {
      trackEvent(
        eventName,
        getEventTrackingData(eventData, vehicle, dashboard, core)
      );
      EventTracked();
    }
  }, [track]);

  return null;
};

export default EventTracking;
